import React, { useContext, useState, useEffect, useRef } from 'react';
import ReactSVG from 'react-svg';
import cash from 'cash.svg';
import { ListingMapContext } from '../../../context/ListingMapContext';
import WindowQuery from '../../../utils/WindowQuery';
import useOutsideClick from '../../../hooks/useOutsideClick';

export default function PriceDropdown() {
  const updateQuery = new WindowQuery();
  const dropdownRef = useRef();

  const [localMinPrice, setLocalMinPrice] = useState('');
  const [localMaxPrice, setLocalMaxPrice] = useState('');
  const [minMaxError, setMinMaxError] = useState('');

  const {
    setMinPrice,
    setMaxPrice,
    setDropdown,
    minPrice,
    maxPrice,
    priceVisible,
  } = useContext(ListingMapContext);

  useEffect(() => {
    if (minPrice) setLocalMinPrice(minPrice);
    if (maxPrice) setLocalMaxPrice(maxPrice);
  }, [maxPrice, minPrice]);

  useOutsideClick(dropdownRef, priceVisible, () => setDropdown(null));

  return (
    <div ref={dropdownRef}>
      <section className="dropdown-filter-row">
        <label htmlFor="min_price_map_filter">
          <h2 className="dropdown-title">Min Price</h2>
          <div className="dropdown-input-container">
            <ReactSVG src={cash} />
            <input
              aria-label="Minimum Price"
              id="min_price_map_filter"
              className="dropdown-filter-input"
              placeholder="0"
              type="number"
              value={localMinPrice}
              onChange={e => setLocalMinPrice(e.target.value)}
              style={{ border: minMaxError ? '1px solid #b94a48' : null }}
            />
          </div>
        </label>

        <label htmlFor="max_price_map_filter" style={{ marginLeft: '15px' }}>
          <h2 className="dropdown-title">Max Price</h2>
          <div className="dropdown-input-container">
            <ReactSVG src={cash} />
            <input
              aria-label="Maximum Price"
              id="max_price_map_filter"
              className="dropdown-filter-input"
              placeholder="None"
              type="number"
              value={localMaxPrice}
              onChange={e => setLocalMaxPrice(e.target.value)}
              style={{ border: minMaxError ? '1px solid #b94a48' : null }}
              onFocus={() => setMinMaxError('')}
            />
          </div>
        </label>
      </section>
      {minMaxError && (
        <div style={{ marginTop: '6px', color: '#b94a48' }}>{minMaxError}</div>
      )}
      <section className="dropdown-apply">
        <button
          aria-label="Apply Price Filter"
          name="Apply Price Filter"
          type="button"
          className="btn btn--dark btn--small apply"
          onClick={() => {
            if (
              localMaxPrice &&
              parseInt(localMaxPrice) < parseInt(localMinPrice)
            ) {
              setMinMaxError('Max must be greater than min');
            } else {
              setMinPrice(localMinPrice);
              setMaxPrice(localMaxPrice);
              setDropdown(null);

              if (localMinPrice) {
                updateQuery.add('min_price', parseInt(localMinPrice));
              } else if (!localMinPrice) {
                updateQuery.remove('min_price');
              }

              if (localMaxPrice) {
                updateQuery.add('max_price', parseInt(localMaxPrice));
              } else if (!localMaxPrice) {
                updateQuery.remove('max_price');
              }
            }
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Price Filter"
          name="Clear Price Filter"
          type="button"
          className="btn btn--small clear-filter"
          onClick={() => {
            setLocalMinPrice('');
            setLocalMaxPrice('');
            setMinPrice('');
            setMaxPrice('');
            updateQuery.remove('min_price');
            updateQuery.remove('max_price');
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
